import { render, staticRenderFns } from "./BtnShop.vue?vue&type=template&id=6ebcc2db&scoped=true&lang=pug&"
import script from "./BtnShop.vue?vue&type=script&lang=js&"
export * from "./BtnShop.vue?vue&type=script&lang=js&"
import style0 from "./BtnShop.vue?vue&type=style&index=0&id=6ebcc2db&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcc2db",
  null
  
)

export default component.exports